/** @jsx jsx */
import { jsx } from "@emotion/react";
import { IParallax } from "@react-spring/parallax";

import appConfig from "../../modules/appConfig";
import ParagraphWithPreferredBreak from "../ParagraphWithPreferredBreak";
import Share from "../Share";

export type FooterProps = {
  data?: {
    title: string;
    slug: string;
    color: string;
  };
  parallax?: IParallax | undefined;
  offset?: number | undefined;
};

export const Footer = (props: FooterProps): React.ReactElement => {
  const data = {
    slug: props.data ? props.data.slug : "",
    title: props.data
      ? `${props.data.title} | ${appConfig.title}`
      : appConfig.title,
    color: props.data ? props.data.color : appConfig.foregroundColor,
  };
  return (
    <footer
      css={{
        paddingTop: "3.5rem",
        paddingBottom: "3rem",
        paddingRight: "1.5rem",
        paddingLeft: "1.5rem",
      }}
    >
      <div
        css={{
          textAlign: "center",
          fontFamily: "'Zilla Slab', serif",
          fontSize: "1.2rem",
        }}
      >
        <ParagraphWithPreferredBreak
          keyPrefix="footer1"
          cssP={{ marginBottom: "1em" }}
        >
          <span>Did our work illuminate</span>
          <span>something hiding in the shadows?</span>
        </ParagraphWithPreferredBreak>
        <ParagraphWithPreferredBreak keyPrefix="footer2">
          <span>You can click below</span>
          <span>
            to <strong>share</strong> this with your beacons.
          </span>
        </ParagraphWithPreferredBreak>
      </div>
      <Share data={data} parallax={props.parallax} offset={props.offset} />
    </footer>
  );
};

export default Footer;
